// ======================= Imports =======================
import React, { useState, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { useFormik } from "formik";
import * as Yup from "yup";
import { api } from "../../../../utility/AxiosInceptor";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { CheckTickBtn, Loginbg, Sniptel } from "../../../../utility";

// ======================= Main Component =======================
const SendOTP = () => {
  // ======================= Refs =======================
  const toast = useRef(null);

  // ======================= State Management =======================
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  // ======================= Formik Setup =======================
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Invalid email").required("Email is required"),
    }),
    onSubmit: async (values) => {
      // ======================= Prepare Data =======================
      const dataToSend = {
        email: formik.values.email,
      };
      setLoading(true);

      // ======================= API Call: Send OTP =======================
      api
        .post(`/api/web/user/forgotPassword`, dataToSend)
        .then((res) => {
          if (res?.status === 200 || res?.status === 201) {
            toast.current.show({
              severity: "success",
              summary: "Email",
              detail: res?.data?.msg,
            });
            setEmailSent(true);
          }
          setLoading(false);
        })
        .catch((err) => {
          toast.current.show({
            severity: "error",
            summary: "Email",
            detail: err?.response?.data?.msg,
          });
          setLoading(false);
        });
    },
  });

  // ======================= Render =======================
  return (
    <div
      className="flex w-full flex-column justify-content-center align-items-center"
      style={{ height: "100vh", background: "white", overflowY: "auto" }}
    >
      {/* ======================= Background ======================= */}
      <div className="bggradient flex w-full">
        <Loginbg />
      </div>

      <Toast ref={toast} />

      {/* ======================= Email Form ======================= */}
      {!emailSent ? (
        <div
          className="flex flex-column align-items-center justify-content-between"
          style={{ height: "58.8rem", width: "48.3rem" }}
        >
          <div className="sniptel">
            <span>
              <Sniptel />
            </span>
          </div>
          <div className="flex flex-column justify-content-center align-items-center forgotpass">
            <div style={{ width: "35.5rem", zIndex: "1" }}>
              <h1>Reset Your Password</h1>
              <p className="flex mt-4">
                Enter your email, and we’ll send you a link to get back on track
                with Sniptel.
              </p>
            </div>
            <div className="flex flex-column " style={{ width: "35.5rem" }}>
              {/* ======================= Email Field ======================= */}
              <div className="flex justify-content-between">
                <label
                  className={
                    formik.touched.email && formik.errors.email
                      ? "emaillabelerr"
                      : "emaillabel"
                  }
                >
                  Email
                </label>
                {formik.touched.email && formik.errors.email ? (
                  <span className="err" style={{ marginTop: "3rem" }}>
                    {formik.errors.email}
                  </span>
                ) : (
                  ""
                )}
              </div>
              <InputText
                id="email"
                name="email"
                className={
                  formik.touched.email && formik.errors.email
                    ? "emailinputerr mt-2"
                    : "emailinput mt-2"
                }
                placeholder="example@email.com"
                value={formik.values.email}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
              />
              {/* ======================= Submit Button ======================= */}
              <div className="flex w-full" style={{ marginTop: "3rem" }}>
                <Button
                  type="submit"
                  loading={loading}
                  onClick={formik.handleSubmit}
                  disabled={
                    formik.values.email === "" || formik.errors.email
                      ? true
                      : false
                  }
                  className="forgetbtn"
                  label="Reset Password"
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        // ======================= Email Sent Confirmation =======================
        <div
          className="flex flex-column align-items-center justify-content-between "
          style={{ width: "48.3rem", height: "49.7rem" }}
        >
          <div className="sniptel">
            <span>
              <Sniptel />
            </span>
          </div>
          <div
            className="flex flex-column justify-content-center align-items-center forgetpasspopup "
            style={{
              width: "48.3rem",
              height: "32.9rem",
              background: "white",
              zIndex: "1",
            }}
          >
            <div>
              <CheckTickBtn />
            </div>
            <div className="flex flex-column align-items-center checkinbox mt-4">
              <h1>Check Your Inbox</h1>
              <p>
                We’ve sent a password reset link to your email. Follow the
                instructions to regain access to your Sniptel account.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SendOTP;
